import { useGroupedRequest } from '@/core/composables/useGroupedRequest';
import { GroupedRequestGroup, GroupedRequestPage } from '@/core/enums/group-request.enum';
import { api } from '@/core/helpers/axiosHelper';
import { SHIFT_ENDPOINTS } from './shift.endpoints';

//TODO: Remove service -> use api directly in components (useGroupedRequest)

export default {
   async getFillRates(
      shift_ids: Array<string | number>,
      fill_rate_type: string,
      date_between: string,
      page: number,
      per_page: number,
      view: string,
   ) {
      const REQUEST_PARAMS = {
         page,
         per_page,
         sort: 'squad.sequence,date',
         'filter[date_between]': date_between,
         'filter[with_slots_count]': fill_rate_type,
         'filter[id]': shift_ids,
         view,
         include: 'shift_fill_rates',
      };

      const response = await useGroupedRequest(
         SHIFT_ENDPOINTS.GET_ALL(),
         GroupedRequestPage.boardDetails,
         GroupedRequestGroup.squadFilter,
         REQUEST_PARAMS,
      );

      return response?.data?.data;
   },
   async postBulk(body: any) {
      return await api.post('/shift/bulk', body).then((response) => response.data);
   },
   async putBulk(body: any) {
      return await api.put('/shift/bulk', body).then((response) => response.data);
   },
   async deleteBulk(body: any) {
      return await api.delete('/shift/bulk', { data: body }).then((response) => response.data);
   },
};
